import { TRIG_ONE, TRIG_STEPS } from "../constants.js";
import { umod } from "./int.js";
import { SIN_TABLE } from "./tables.js";

/**
 * Integer trigonometry.
 *
 * Angles are measured in *steps*: `TRIG_STEPS` (256) steps make a full turn, so
 * one step is 1.40625°. Results are Q12 (`TRIG_ONE` = 4096 represents 1.0).
 *
 * There is no runtime floating point here. The table is generated once by
 * `tools/codegen.ts` and shared verbatim with `Trig.sol`.
 */

export { TRIG_ONE, TRIG_STEPS };

/** A quarter turn, in steps. */
export const QUARTER_TURN = TRIG_STEPS / 4;

/** sin(angle), Q12. Accepts any integer angle, positive or negative. */
export function sin(steps: number): number {
  return SIN_TABLE[umod(steps, TRIG_STEPS)] as number;
}

/** cos(angle), Q12. */
export function cos(steps: number): number {
  return SIN_TABLE[umod(steps + QUARTER_TURN, TRIG_STEPS)] as number;
}

/** Convert whole degrees to the nearest step. Generation-time helper only. */
export function degreesToSteps(deg: number): number {
  return Math.round((deg * TRIG_STEPS) / 360);
}
